<template>
  <div>
    <Head :title="form.nama" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/persyaratans">Persyaratan</Link>
      <span class="font-medium text-indigo-400">/</span>
      {{ persyaratan.nama }}
    </h1>
    <div class="w-full overflow-hidden bg-white rounded-md shadow">
      <form @submit.prevent="update">
        <div class="flex flex-wrap p-8 -mb-8 -mr-6">
          <text-input v-model="form.nama" :error="form.errors.nama" class="w-full pb-8 pr-6" label="Nama Persyaratan" />
          <div class="flex w-full pb-8 pr-6 lg:w-1/3">
            <input id="mou_prestasi" v-model="form.mou_prestasi" type="checkbox" class="mr-2" />
            <label for="mou_prestasi" class="flex flex-row items-center cursor-pointer">
              Prestasi
            </label>
          </div>
          <div class="flex w-full pb-8 pr-6 lg:w-1/3">
            <input id="mou_nonprestasi" v-model="form.mou_nonprestasi" type="checkbox" class="mr-2" />
            <label for="mou_nonprestasi" class="flex flex-row items-center cursor-pointer">
              Pra-Sejahtera
            </label>
          </div>
        </div>
        <div class="flex items-center px-8 py-4 border-t border-gray-100 bg-gray-50">
          <Link class="btn-red" href="/persyaratans">
            <font-awesome-icon class="mr-2" icon="fas fa-arrow-left" />Kembali
          </Link>
          <loading-button :loading="form.processing" class="ml-auto btn-green" type="submit">
            <font-awesome-icon class="mr-2" icon="fas fa-key" />Simpan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    persyaratan: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nama: this.persyaratan.nama,
        mou_prestasi: this.persyaratan.mou_prestasi,
        mou_nonprestasi: this.persyaratan.mou_nonprestasi,
        mandiri: this.persyaratan.mandiri,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/persyaratans/${this.persyaratan.id}`)
    },
  },
}
</script>
